import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-infobox',
  templateUrl: './infobox.component.html',
  styleUrls: ['./infobox.component.scss'],
})
export class InfoboxComponent implements OnInit {
  @Input() title!: string;
  @Input() content!: string;
  @Input() isSummary: boolean = false;
  @Input() barometer: boolean = false;
  @Input() locale: string = 'default';

  constructor() {}

  ngOnInit(): void {}
}
